/**
 * @file
 * A JavaScript file for the site.
 *
 * 
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:

// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

(function ($) {
  $('.js-banner-close-btn').each(function(){
    var $targetClass = $(this).data('target');

    $(this).click(function(){
      $(this).closest('.' + $targetClass).slideUp();
    });
  });
}(jQuery));
